import { Alert, Stack, Typography } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { IVendorQuoteImportRangeReport } from 'dashboard/types';
import { Color, Level, Size, Variant } from 'theme/enums';

const ICON_SIZE = 24;

interface IProps {
  report?: IVendorQuoteImportRangeReport;
}

export const ReportDiagnostics = ({ report }: IProps) => {
  const { t } = useTranslation();

  const warnings = report?.warnings ?? [];
  const skippedLineCount = report?.skippedLineCount ?? 0;

  if (!warnings.length && !skippedLineCount) {
    return null;
  }

  return (
    <Alert
      startDecorator={<Warning size={ICON_SIZE} />}
      variant={Variant.SOFT}
      color={Color.WARNING}
      size={Size.LG}
      sx={{ alignItems: 'flex-start', width: '100%' }}
    >
      <Stack gap={0.5}>
        <Typography level={Level.TITLE_SM}>{t('labelWarnings')}</Typography>

        {/* Index key: warnings are BE-supplied strings and two can be identical. */}
        {warnings.map((warning, index) => (
          <Typography key={index} level={Level.BODY_SM}>
            {warning}
          </Typography>
        ))}

        {!!skippedLineCount && (
          <Typography level={Level.BODY_SM}>
            {t('labelSkippedLogLines', { value: skippedLineCount })}
          </Typography>
        )}
      </Stack>
    </Alert>
  );
};
